import { render } from "./pot-analysis.vue?vue&type=template&id=210b335a"
import script from "./pot-analysis.vue?vue&type=script&lang=js"
export * from "./pot-analysis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/pot/pot-analysis.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "210b335a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('210b335a', __exports__)) {
    api.reload('210b335a', __exports__)
  }
  
  module.hot.accept("./pot-analysis.vue?vue&type=template&id=210b335a", () => {
    api.rerender('210b335a', render)
  })

}


export default __exports__